import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const Container = styled("div")`
    @media (min-width: ${breakpoints.values.md}px) {
        align-items: center;
    }
`

export const Wrapper = styled("div")`
    display: flex;
    align-items: center;
`
